import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import * as whiteLabelActions from 'redux/modules/whiteLabel';
import { LeftNavLayout } from 'containers';
import { PageHeader, WhiteLabelForm } from 'components';
import { connect } from 'react-redux';
import { loadTheme } from 'redux/modules/theme';
import Snackbar from 'material-ui/Snackbar';
var WhiteLabel = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    theme: state.theme,
    uploadingFile: state.whiteLabel.uploadingFile
  };
}, _objectSpread(_objectSpread({}, whiteLabelActions), {}, {
  loadTheme: loadTheme
})), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(WhiteLabel, _Component);

  var _super = _createSuper(WhiteLabel);

  function WhiteLabel(props) {
    var _this;

    _classCallCheck(this, WhiteLabel);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function (data) {
      var orgId = _this.props.theme.org;

      _this.setState({
        saving: true
      });

      _this.props.submit(orgId, data).then(function () {
        window.location.reload();
      })["catch"](function (err) {
        _this.setState({
          saving: false,
          snackbarOpen: true,
          snackbarMessage: 'There was an issue trying to save your white label settings. Please try again.'
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleRequestClose", function () {
      _this.setState({
        snackbarOpen: false
      });
    });

    _this.state = {
      snackbarOpen: false,
      snackbarMessage: '',
      saving: false
    };
    return _this;
  }
  /** *********************************************************************************************
   EVENT HANDLER METHODS
  ************************************************************************************************/


  _createClass(WhiteLabel, [{
    key: "render",
    value:
    /** *********************************************************************************************
     RENDER METHOD
    ************************************************************************************************/
    function render() {
      var theme = this.props.theme;
      console.log('in WhiteLabel');
      console.log(theme);
      return /*#__PURE__*/React.createElement(LeftNavLayout, {
        sidebar: "admin"
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "White Label"
      }), /*#__PURE__*/React.createElement(Snackbar, {
        message: this.state.snackbarMessage,
        open: this.state.snackbarOpen,
        autoHideDuration: 4000,
        onRequestClose: this.handleRequestClose
      }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement(PageHeader, {
        primary: "Admin",
        secondary: "White Labeling",
        style: {
          borderBottom: '1px solid #f1f1f1',
          paddingBottom: 16,
          marginBottom: 0,
          marginTop: 16
        }
      })), /*#__PURE__*/React.createElement(WhiteLabelForm, {
        saving: this.state.saving,
        onSubmit: this.handleSubmit,
        initialValues: {
          primaryColor: theme.colors.primaryColor,
          secondaryColor: theme.colors.secondaryColor,
          domain: theme.domain,
          logoUrl: theme.logo[0]
        }
      })));
    }
  }]);

  return WhiteLabel;
}(Component)) || _class);
export default WhiteLabel;